<template>

      <NTable
        id="cmp-licensing-account-licence-modal"
        class="h1"
        :config="tableConfig"
        :headers="headers"
        :items="list"
        :loadingFlag="loadingFlag"
        @scrollnext="onScrollNext"
        :height="32 * list.length +  ''"
      >
        <template v-slot:item="{ item,index, tdcon }">
          <tr>
            <td :class="{ borderBottom: indexArray.includes(index) }" v-bind="tdcon('asset_type')">
              <span> {{ item['asset_type'] }} </span>
            </td>
            <td :class="{ borderBottom: indexArray.includes(index) }" v-bind="tdcon('identifier')">
              <span> {{ item['identifier'] }} </span>
            </td>
            <td :class="{ borderBottom: indexArray.includes(index) }" v-bind="tdcon('artist')">
              <span> {{ item['artist'] }} </span>
            </td>
            <td :class="{ borderBottom: indexArray.includes(index) }" v-bind="tdcon('title1')">
              <span> {{ item['title'] }} </span>
            </td>
            <td  :class="{ borderBottom: indexArray.includes(index) }" style="border-right:1px solid var(--row-bottom-border-color)!important;" v-bind="tdcon('currency')">
              <span> {{ item['currency'] }} </span>
            </td>
            <td class="borderRight" v-bind="tdcon('sales_info')">
              <TextField2
                type="text"
                class="dbox1"
                id="sales_info"
                :showLabel="false"
                :disabled="false"
                :value="item['sales_info']"
                :bb="'0px'"
                :ta="'right'"
                @change="e => onTextFieldChange(e, item)"
              />
            </td>
            <td class="borderRight" v-bind="tdcon('qty')">
              <TextField2
                type="number"
                class="dbox1"
                id="qty_info"
                :showLabel="false"
                :disabled="false"
                :value="item['qty_info']"
                :bb="'0px'"
                :ta="'right'"
                @change="e => onTextFieldChange(e, item)"
              />
            </td>
            <td class="borderRight" v-bind="tdcon('statement')">
              <TextField2
                type="number"
                class="dbox1"
                id="statement_amount"
                :showLabel="false"
                :disabled="false"
                :value="item['statement_amount']"
                :bb="'0px'"
                :ta="'right'"
                @change="e => onTextFieldChange(e, item)"
              />
            </td>
            <td class="borderRight" v-bind="tdcon('reserves')">
              <TextField2
                type="number"
                class="dbox1"
                id="reserve_amount"
                :showLabel="false"
                :disabled="false"
                :value="item['reserve_amount']"
                :bb="'0px'"
                :ta="'right'"
                @change="e => onTextFieldChange(e, item)"
              />
            </td>
            <td class="borderRight" v-bind="tdcon('balance')">
              <TextField2
                type="number"
                class="dbox1"
                id="balance_amount"
                :showLabel="false"
                :disabled="false"
                :value="item['balance_amount']"
                :bb="'0px'"
                :ta="'right'"
                @change="e => onTextFieldChange(e, item)"
              />
            </td>
            <td class="borderRight"  v-bind="tdcon('invoice')">
              <TextField2
                type="number"
                class="dbox1"
                id="invoice_amount"
                :showLabel="false"
                :disabled="false"
                :value="item['invoice_amount']"
                :bb="'0px'"
                :ta="'right'"
                @change="e => onTextFieldChange(e, item)"
              />
            </td>
            <td class="borderRight" style="border-right:0px !important" v-bind="tdcon('duplicate')">
              <img
                @click.stop="e => duplicateLicence(item,index)"
                src="static/icons/double-plus.svg"
                class="dt-icon v5 s2 ut-center"
              />
          </td>
          </tr>
        </template>
        <template v-slot:tfoot="{ thcon }">
          <tr class="table-footer">
            <td v-bind="thcon('asset_type')"></td>
            <td v-bind="thcon('identifier')"></td>
            <td v-bind="thcon('artist')"></td>
            <td v-bind="thcon('title1')"></td>
            <td v-bind="thcon('currency')"></td>
            <td v-bind="thcon('sales_info')"></td>
            <td v-bind="thcon('qty')"></td>
            <td v-bind="thcon('statement')" style="text-align: right;"><span>{{ statementTotal.toLocaleString('en-US')  }}</span></td>
            <td v-bind="thcon('reserves')" style="text-align: right;"><span>{{ reserveTotal.toLocaleString('en-US') }}</span></td>
            <td v-bind="thcon('balance')" style="text-align: right;"><span>{{ balanceTotal.toLocaleString('en-US') }}</span></td>
            <td v-bind="thcon('invoice')" style="text-align: right;"><span>{{ invoiceTotal.toLocaleString('en-US') }}</span></td>
            <td v-bind="thcon('duplicate')"></td>
          </tr>
        </template>
      </NTable>

</template>

<script>

import * as ActionTypes from "../../store/types";
import { DTIconButton } from "../../../../plugins/button/button";
import NTable from "../../../../plugins/datatable/datatable";

import InputField from "@plugins/text-field/input-field";


import { createNTableConfig } from "../../../../plugins/datatable";

import { createTableHeader } from "../../../../plugins/datatable";
import ModalContainer from "@dtplugins/modal/modal-container";

import { openModalRoute2 } from "../../../../dt-plugins/modal/modal.mixin";

import { defaultConfig } from "@/dt-plugins/sidewindow/config.model";



export default {
  props: {
    loadingFlag: {
      type: Boolean,
      default: false,
    },
    tableIndex: {
      type: Number,
      required:true
    },
    listItem: {
      type: Object,
    },
    showHeaderFlag: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    NTable,
    InputField,
    DTIconButton,
    ModalContainer,

    //AdvanceSearch,
  },
  mounted: function () {
    

    
    //console.log(externalKeyList,"PPPPPPPPPP",this.countArray);


  },
  data: function () {
    return {
      defaultConfig: defaultConfig,
      searchType: "none",
      //countArray:[]
    };
  },
  mixins: [],
  watch: {
    $route: {
      immediate: true,
      handler: function (to, from) {},
    },
  },
  computed: {

    indexArray:function(){
      const externalKeyList =  Object.groupBy(this.list, ({ external_table }) => external_table);
    
      const countArray = Object.values(externalKeyList).map(x=>{
        return x.length;
      });

      if(countArray.length==3){
        return [ countArray[0]-1,countArray[0]+countArray[1]-1  ]
      }else if(countArray.length==2){
        return [ countArray[0]-1,(countArray[0]+countArray[1])-1  ]
      }else{
        return [];
      }
    },
   

    tableConfig: function () {
      return createNTableConfig({
        fullHeight: true,
        headerStyle: 3,
        showHeader:true,
        footer: true,
      });
    },

    statementTotal:function(){
      if(this.list.length>0){

        return this.list.reduce((accum,cur)=>{
          
          console.log("typeof cur['statement_amount'] === 'number'",cur['statement_amount'])
          
          return cur['statement_amount'] !== ''?accum+=parseFloat(cur['statement_amount']):accum+=0;
        },0)
      }

      return 0;
    },

    reserveTotal:function(){
      if(this.list.length>0){
        return this.list.reduce((accum,cur)=>{
          return cur['reserve_amount'] !== ''? accum+=parseFloat(cur['reserve_amount']):accum+=0;
        },0)
      }

      return 0;
    },
    balanceTotal:function(){
      
      if(this.list.length>0){
        return this.list.reduce((accum,cur)=>{
          return cur['balance_amount'] !== ''? accum+=parseFloat(cur['balance_amount']):accum+=0;
        },0)
      }

      return 0;
    },

    invoiceTotal:function(){
      
      if(this.list.length>0){
        return this.list.reduce((accum,cur)=>{
          return cur['invoice_amount'] !== ''? accum+=parseFloat(cur['invoice_amount']):accum+=0;
        },0)
      }

      return 0;
    },


    list: function () {
      return this.listItem?.items||[];
    },

    listLength:function () {
      return this.list.length;
    },

    headers: function () {
      return [
        createTableHeader("asset_type", { text:this.list[0]['licence_name'] }),
        createTableHeader("identifier", {  text:this.list[0]['last_statement'] }),
        createTableHeader("artist", { text:false }),
        createTableHeader("title1", { text:false }),
        createTableHeader("currency", { text:this.list[0]['invoice'] }),
        createTableHeader("sales_info", { text:this.$t('sales_info')||'' }),
        createTableHeader("qty", { text:this.$t('qty')||'',ta:'right' }),
        createTableHeader("statement", { ta:'right' }),
        createTableHeader("reserves", { ta:'right'}),
        createTableHeader("balance", {ta:'right'}),
        createTableHeader("invoice", { ta:'right'}),
        createTableHeader("duplicate", { text: false, mw: 30 }),
      ];
      //this.list[0]['invoice']
    },

  },
  methods: {
   
    onScrollNext: function () {},
    onTextFieldChange:function(event,item){
      console.log(event,item)
      const { name ,value } = event;
      const { composite_key } = item;

      //console.log("10",this.list)

      this.$emit('change',{ name:name ,value:value , tableIndex:this.tableIndex ,composite_key:composite_key })
      
      //console.log("20",this.list)



    },

    duplicateLicence: function(item,index) {
      this.$emit('duplicate',{ tableIndex:this.tableIndex ,item:item,index:index })
    },

  },
};
</script>

<style lang="scss">
.cmp-licensing-account-licence-modal{
  &:not(:first-child) {
    //  margin-top: 20px;
  }
  .borderRight{
    border-right:1px solid var(--row-bottom-border-color)!important;
    border-bottom: 1px solid var(--row-bottom-border-color)!important
  }
  .borderBottom{
    border-bottom: 1px solid var(--row-bottom-border-color)!important
  }
  tbody{
    tr{
        border-bottom:0px;
        td{
          //border-bottom: 1px solid var(--row-bottom-border-color)
        }
      }
      
  }

    thead {
      background-color: black;
      .sales_info{
        background-color: white;
      }
      .qty{
        background-color: white;
      }
      .statement{
        background-color: white;
      }
      .reserves{
        background-color: white;
      }
      .balance{
        background-color: white;
      }
      .invoice{
        background-color: white;
      }
      .duplicate{
        background-color: white;
      }
      tr {
        /// border-top: 1px solid var(--bc-accent);
        //color: var(--bc-accent);
        color: white;
      }
    }

    .table-footer {
      //color: var( --sprt-85);
      //border-bottom: 1px solid rgba(0,0,0,0.12);
    }  

  
}
</style>
